import styled from 'styled-components';

export const PageHeader = styled.div`
  position: sticky;
  top: -26px;
  z-index: 1;
  margin-bottom: 36px;
  z-index: 2;
  margin: -26px -100px 0;
  padding: 16px 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  background-color: ${({ theme }) => theme.colors['neutral-20']};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    padding-left: 105px;
    padding-right: 105px;
  }
`;
